// src/services/DataService.ts
import { Competition, Solution, User, Tag, DataDomain } from '../models';

/**
 * データサービスインターフェース
 * データの読み込み、保存、検索などの操作を定義
 */
export interface DataService {
  // コンペティション関連
  getCompetitions(): Promise<Competition[]>;
  getCompetitionBySlug(slug: string): Promise<Competition | null>;
  searchCompetitions(query: CompetitionSearchQuery): Promise<Competition[]>;
  findSimilarCompetitions(slug: string, similarityType: SimilarityType, limit?: number): Promise<Competition[]>;
  
  // ソリューション関連
  getSolutions(): Promise<Solution[]>;
  getSolutionsByCompetition(competitionSlug: string): Promise<Solution[]>;
  searchSolutions(query: SolutionSearchQuery): Promise<Solution[]>;
  
  // ユーザー関連
  getUsers(): Promise<User[]>;
  getUserById(userId: string): Promise<User | null>;
  
  // タグとドメイン関連
  getTags(): Promise<Tag[]>;
  getDataDomains(): Promise<DataDomain[]>;
  
  // データ更新関連
  updateData(data: DataUpdate): Promise<void>;
}

/**
 * コンペティション検索クエリインターフェース
 */
export interface CompetitionSearchQuery {
  text?: string;
  tags?: string[];
  dataDomain?: string;
  startDate?: string;
  endDate?: string;
  minParticipants?: number;
  maxParticipants?: number;
  isActive?: boolean;
}

/**
 * ソリューション検索クエリインターフェース
 */
export interface SolutionSearchQuery {
  competitionSlug?: string;
  minRank?: number;
  maxRank?: number;
  minScore?: number;
  maxScore?: number;
  userId?: string;
  text?: string;
}

/**
 * 類似性の種類を定義する列挙型
 */
export enum SimilarityType {
  TITLE = 'title',
  TAGS = 'tags',
  DATA_DOMAIN = 'dataDomain',
  DESCRIPTION = 'description',
  ALL = 'all'
}

/**
 * データ更新インターフェース
 */
export interface DataUpdate {
  competitions?: Competition[];
  solutions?: Solution[];
  users?: User[];
  tags?: Tag[];
  dataDomains?: DataDomain[];
}
